<template>
  <Modal
    v-model="_value"
    width="600"
    title="技术协助处理"
    @on-visible-change="visibleChange"
    ok-text="完成"
    @on-ok="onOk">
    <Form ref="loginForm" :model="technicalAssistance" :label-width="80" >
      <Row>
        <Col span="12">
      <FormItem prop="vehicleInfoId" label="问题车辆">
        <label style="display: inline-block; width: 100px;">{{technicalAssistance.vehicleInfo.registrationNum}}</label>
      </FormItem>
        </Col>
        <Col span="12">
      <FormItem prop="positioningDeviceInfo" label="问题设备">
        <label style="display: inline-block;">{{technicalAssistance.positioningDeviceInfo.terminalNum}}({{technicalAssistance.positioningDeviceInfo.positioningDeviceModel.name}})</label>
      </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem prop="qghyptOption" label="是否加急">
            <Space direction="vertical" size="large">
              <RadioGroup v-model="technicalAssistance.urgent">
                <Radio label="是" disabled></Radio>
                <Radio label="否" disabled></Radio>
              </RadioGroup>
            </Space>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
      <FormItem prop="question" label="问题描述">
        <Input class="field" v-model="technicalAssistance.question" type="textarea" disabled>
        </Input>
      </FormItem>
        </Col>
      </Row>
        <Row>
          <Col span="24">
      <FormItem prop="remark" label="备注">
          <Input class="field" v-model="technicalAssistance.remark" type="textarea" disabled>
          </Input>
      </FormItem>
          </Col>
        </Row>

      <Row>
        <Col span="12">
          <FormItem prop="businessUserId" label="处理状态">
            <Select style="width: 100px;" v-model="technicalAssistance.state">
              <Option v-for="item in stateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>
        </Col>
          <Col span="12">
            <FormItem prop="businessUserId" label="观察时间">
              <DatePicker type="datetime" v-model="technicalAssistance.observationDatetime"
                          placeholder="选择日期"></DatePicker>
            </FormItem>
          </Col>
      </Row>
        <Row>
          <Col span="24">
            <FormItem prop="state" label="处理结果" v-if="technicalAssistance.step != null">
              <Select style="width: 100px;" v-model="technicalAssistance.step.state">
                <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
          <FormItem prop="result" label="处理内容" v-if="technicalAssistance.step != null">
            <Input style="display: inline-block;" type="textarea" v-model="technicalAssistance.step.result"
                   placeholder="处理内容">
            </Input>
          </FormItem>
          </Col>
        </Row>

    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'technicalassistanceconfirmassistancemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      stateOptions: [
        { label: '处理', value: 1 }
        // {label: '观察', value: 2},
        // {label: '完成', value: 3},
      ],

      stepstateOptions: [
        { label: '通过', value: 2 },
        { label: '不通过', value: 3 }
      ],

      searchVehicleInfoLoading: false,
      searchVehicleInfoList: [],

      technicalAssistance: {
        businessUserId: null,
        businessUser: null,
        createUserId: null,
        createUser: null,
        vehicleInfoId: null,
        vehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            id: null,
            name: null
          },
          vehicleBrand: {
            id: null,
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            id: null,
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        positioningDeviceInfoId: null,
        positioningDeviceInfo: {
          id: null,
          terminalNum: null,
          factoryTerminalNum: null,
          positioningDeviceModel: null,
          positioningDeviceModelId: null,
          sourceType: null,
          remark: null,
          setupDatetime: null,
          serviceDatetime: null,
          positioningDeviceModel: {
            name: null
          }
        },
        updateDatetime: null,
        assistanceDatetime: null,
        question: null,
        state: 1,
        result: null,
        remark: null,
        urgent: '否',
        observationDatetime: null,
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        }
      },

      positioningDeviceInfosTypeOptions: []

    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    onOk () {
      if (this.technicalAssistance.receptDatetime == '是') {
        this.technicalAssistance.receptDatetime = new Date()
      } else {
        this.technicalAssistance.receptDatetime = null
      }
      if (this.technicalAssistance.urgent == '是') {
        this.technicalAssistance.urgent = true
      } else {
        this.technicalAssistance.urgent = false
      }
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认完成技术协助</p>',
        onOk: () => {
          // console.log(this.technicalAssistance)

          store.dispatch('TechnicalAssistanceServ_ConfirmMaintained', { params: this.technicalAssistance }).then(() => {
            // this.$Message.success('添加技术协助成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.technicalAssistance.vehicleInfoId = null
        this.technicalAssistance.question = null
        this.technicalAssistance.remark = null
        this.positioningDeviceInfosTypeOptions = []

        store.dispatch('TechnicalAssistanceServ_GetDetail', {
          params: {
            id: this._initValue
          }
        }).then(() => {
          this.technicalAssistance = store.getters.get_TechnicalAssistance_GetDetailResult
          if (this.technicalAssistance.urgent) {
            this.technicalAssistance.urgent = '是'
          } else {
            this.technicalAssistance.urgent = '否'
          }
          this.technicalAssistance.step.state = 2
          this.$emit('on-success')
        }).catch(err => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
